export default "/public/dist/resources/Allegato2Dichiarazione14febbraio2023.pdf";